function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.0137 37.1321C25.4086 37.1321 24.1063 35.8642 24.1063 34.2641C24.1063 32.6642 25.4086 31.366 27.0137 31.366C28.6189 31.366 29.8909 32.6642 29.8909 34.2641C29.8909 35.8642 28.6189 37.1321 27.0137 37.1321ZM52.9689 33.9321L35.403 5.28302C34.4338 3.86415 33.3435 2.59623 32.0109 1.63019C30.5875 0.603774 28.952 0 27.0137 0C25.0754 0 23.44 0.603774 21.9862 1.63019C20.684 2.59623 19.5937 3.86415 18.6245 5.28302L0.967742 34.083C-0.364844 36.8302 -0.364844 39.9698 1.24032 42.5962C2.66376 44.9208 5.1775 46.4 7.90324 46.4H46.0939C48.85 46.4 51.3334 44.9208 52.7569 42.5962C54.362 40 54.4226 36.6189 52.9689 33.9321ZM27.0137 28.4981C25.9537 28.4981 25.1966 27.6226 25.0754 26.566L24.1063 17.9019C23.9548 16.4226 25.5297 15.034 27.0137 15.034C28.4977 15.034 30.0726 16.4226 29.8909 17.9019L28.9217 26.566C28.8309 27.6226 28.0737 28.4981 27.0137 28.4981Z",
  fill: "#E91868"
});

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 47,
    viewBox: "0 0 54 47",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.86ad89d4.svg";
export { ForwardRef as ReactComponent };